(ns client-portal.client.voice-insights.sessions.drill
  (:require [client-portal.client.components.drill :as drill]
            [client-portal.client.voice-insights.sessions.data :as sessions.d]
            [shared.core.reactive :as re]
            [shared.core.router :as router]
            [shared.core.util :as util]))

(defn- filter-value
  "A chart value as the option the Sessions filter `by` selects for it, or nil when it
   names none. A tags value is one of `tag`'s values, or a {tag, value} pair."
  [by v {:keys [tag op]}]
  (case by
    "tags" (let [[tag v] (if (map? v) [(:tag v) (:value v)] [tag v])]
             (when (drill/value-set? tag)
               (drill/option (str tag) (str v))))
    "day-part" (drill/option (util/->capitalize-words (str v)) (str v))
    "day-of-week" (drill/day-of-week-option v)
    "time-of-day" (drill/time-of-day-option v)
    "duration" (drill/duration-option v)
    ;; A 0s lower bound bounds nothing.
    "utterance-start" (when (and op (pos? (util/parse-int v)))
                        {:op op :value (str v)})
    nil))

(defn session-filters
  "A point's constraints as the tags-based Sessions filters Voice Insights and smart
   ordering share, limited to the `bys` the page offers. A `tag-child` constraint narrows
   every tags filter of the same point, as a child tag does in the filter."
  [constraints bys]
  (let [children (->> constraints
                      (filter #(= "tag-child" (:filter %)))
                      (keep (fn [{:keys [tag values condition]}]
                              (when-let [values (->> values (filter drill/value-set?) (mapv str) (not-empty))]
                                (when (drill/value-set? tag)
                                  {:by (str tag)
                                   :condition (or condition "include")
                                   :join "or"
                                   :value values}))))
                      (vec))]
    (->> constraints
         (filter #(contains? bys (:filter %)))
         (keep (fn [{by :filter :keys [values condition join] :as c}]
                 (when-let [value (->> values
                                       (filter drill/value-set?)
                                       (keep #(filter-value by % c))
                                       (vec)
                                       (not-empty))]
                   (cond-> {:by by
                            :condition (or condition "include")
                            :join (or join (if (sessions.d/comparison-filter? by) "and" "or"))
                            :value value}
                           (= by "tags") (assoc :children children)))))
         (vec))))

(defn sessions-query-params [{:keys [crew-type query-params] :as context} {:keys [utterances?] :as drill} click report-filters]
  (let [constraints (drill/constraints drill click context report-filters)]
    (util/remove-nil-from-map
      (merge (select-keys query-params [:ns :dsid :ds])
             (drill/layout-query-params context constraints report-filters)
             {:ct (when (drill/report-filter-enabled? report-filters :crew-type) crew-type)
              :svm (when utterances? "utterances")
              :fd (sessions.d/filters->query-param
                    (session-filters constraints #{"tags" "day-of-week" "time-of-day" "day-part" "duration" "utterance-start"}))}))))

(defn open-sessions [e context drill click report-filters]
  (router/open-route-based-on-event e
                                    [:vi/sessions nil (sessions-query-params context drill click report-filters)]
                                    :on-route-change #(re/dispatch [:sessions/reload-conversations-list])))
